// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import AuthLayout from "./components/portal/layout/AuthLayout";

// Import your page components
import Landing from "./components/landing/Landing";

import Login from "./components/Login";
import ConfirmEmail from "./components/ConfirmEmail";
import ResetPassword from './components/ResetPassword';

import PrivacyPolicy from "./components/legal/privacy/Privacy.js";
import Terms from "./components/legal/terms/Terms.js";

import ViewModel from './components/3DModelling/ViewModel.js'

import ViewModelMaterialCubeRoom from './components/3DModelling/ViewModelMaterial - Cube room.js'
import ViewModelMaterialBaseRoom from './components/3DModelling/ViewModelMaterial - Base room.js'
import ViewModelMaterialBathroom from './components/3DModelling/bathroom/ViewModelMaterial - Bathroom.js'

import Report from "./components/report/Report";
import PortalHome from "./components/portal/home/PortalHome";
import PortalProperties from "./components/portal/properties/PortalProperties";
import PortalProperty from "./components/portal/property/PortalProperty";
import ViewReport from "./components/portal/ViewReport/ViewReport";
// Import additional pages like ForgotPassword, Register as needed
import PortalSupport from "./components/portal/support/Support";

import "./index.css"; // Ensure Tailwind CSS is imported

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/report" element={<Report />} />
        <Route path="/login" element={<Login />} />
        <Route path="/confirm-email" element={<ConfirmEmail />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<Terms />} />

        
        <Route path="/viewModel" element={<ViewModel />} />
        <Route path="/viewModelMaterialCube" element={<ViewModelMaterialCubeRoom />} />
        <Route path="/viewModelMaterialBaseRoom" element={<ViewModelMaterialBaseRoom />} />
        <Route path="/viewModelMaterialBathroom" element={<ViewModelMaterialBathroom />} />
        
        {/* Add additional public routes like Register, ForgotPassword */}
        {/* <Route path="/register" element={<Register />} /> */}
        {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}

        {/* Protected Routes */}
        <Route
          path="/portal/*"
          element={
            <PrivateRoute>
              <AuthLayout />
            </PrivateRoute>
          }
        >
          {/* Nested Protected Routes */}
          <Route path="" element={<PortalHome />} />
          <Route path="properties" element={<PortalProperties />} />
          <Route path="property" element={<PortalProperty />} />
          <Route path="viewReport" element={<ViewReport />} />
          <Route path="support" element={<PortalSupport />} />
          
          {/* Add additional nested portal routes here */}
          <Route index element={<PortalHome />} /> {/* Default route under /portal */}
        </Route>

        {/* Root Route - Redirect or Welcome Page */}
        <Route
          path="/"
          element={
            <Landing/>
          }
        />

        {/* Fallback Route - Redirect to /report */}
        <Route path="*" element={<Report />} />
      </Routes>
    </Router>
  );
}

export default App;
